export default __webpack_public_path__ + "static/media/D0270.34I-25616_-23193_0.1695742800000.42368522.jpg";